export default __webpack_public_path__ + "static/HIPPA-d526e2055135ac88518d63b499471601.svg";